import React from 'react';
import {
  View,
} from 'react-native';
//= ========================================================================

const EmptyFullPageSimulator = (
) => (
  <View />
);
export default EmptyFullPageSimulator;
